import { IHttpApi } from '@cian/http-api/shared';
import { ILogger } from '@cian/logger/shared';
import { ISuggestResponseSchema } from '../../repositories/newbuilding-promos/entities/suggest/SuggestResponseSchema';
import { fetchGetSuggest, TGetSuggestResponse } from '../../repositories/newbuilding-promos/v1/get-suggest';
import { ResponseError } from '../../utils/errors';

interface IResolveSuggestionsParams {
  httpApi: IHttpApi;
  logger: ILogger;
  /** Запрос пользователя **/
  query: string;
  /** Поддомен **/
  subdomain: string;
}

export async function resolveSuggestions({
  httpApi,
  logger,
  query,
  subdomain,
}: IResolveSuggestionsParams): Promise<ISuggestResponseSchema> {
  try {
    const response: TGetSuggestResponse = await fetchGetSuggest({
      httpApi,
      parameters: {
        query,
        subdomain,
      },
    });

    if (response.statusCode !== 200) {
      const { errors, message } = response.response;

      throw new ResponseError({
        message: message || '',
        domain: 'services.resolveSearchPromosPage',
        details: { errors: JSON.stringify(errors) },
      });
    }

    return response.response;
  } catch (error) {
    logger.error(error);

    throw error;
  }
}
